import { ResponsiveLine } from '@nivo/line';

const data = [
    {
        id: 'dotted-line',
        data: [
            { x: 'Jan', y: 10 },
            { x: 'Feb', y: 25 },
            { x: 'Mar', y: 15 },
            { x: 'Apr', y: 35 },
        ],
        
    },
    {
        id: 'dotted-line2',
        data: [
            { x: 'Jan', y: 2 },
            { x: 'Feb', y: 15 },
            { x: 'Mar', y: 45 },
            { x: 'Apr', y: 25 },
        ],
    }
];

const MyDottedLineChart = () => (
    <ResponsiveLine
        data={data}
        margin={{ top: 50, right: 110, bottom: 50, left: 60 }}
        xScale={{ type: 'point' }}
        yScale={{ type: 'linear', min: 0, max: 'auto', stacked: false, reverse: false }}
        axisLeft={{ legend: 'Value', legendOffset: -40, legendPosition: 'middle' }}
        axisBottom={{ legend: 'Month', legendOffset: 36, legendPosition: 'middle' }}
        colors={{ scheme: 'category10' }}
        lineWidth={2}
        pointSize={10}
        pointColor={{ theme: 'background' }}
        pointBorderWidth={2}
        pointBorderColor={{ from: 'serieColor' }}
        useMesh={true}
        enablePoints={true}
        enableGridX={false}
        enableGridY={false}
        layers={[
            'grid',
            'markers',
            'axes',
            'areas',
            'crosshair',
            'points',
            'slices',
            'mesh',
            ({ series, lineGenerator, xScale, yScale }) => (
                <g>
                    {series.map(({ id, data, color }) => (
                        <path
                            key={id}
                            d={lineGenerator(
                                data.map(d => ({
                                    x: xScale(d.data.x),
                                    y: yScale(d.data.y),
                                }))
                            )}
                            fill="none"
                            stroke={color}
                            strokeWidth={1}
                            strokeDasharray="5 5" // Dotted Line Effect
                        />
                    ))}
                </g>
            ),
        ]}
    />
);

export default MyDottedLineChart;
